import { CloseCircleOutlined } from '@ant-design/icons'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import React, { Dispatch, SetStateAction } from 'react'
import styled, { CSSProperties } from 'styled-components'
import { KVMarkup, KVMeasurement } from 'types'

const CloseButtonContainer = styled.div`
  position: absolute;
  cursor: pointer;
`

export const CloseButton: React.FC<{
  setSelectedMarkup: Dispatch<SetStateAction<KVMarkup | undefined>>
  style?: CSSProperties
}> = ({ setSelectedMarkup, style }) => {
  const { sendCommand, selectedMarkup } = useKestrelViewerContext()

  return (
    <CloseButtonContainer
      style={style}
      onClick={() => {
        setSelectedMarkup(undefined)
        // If we're closing a measurement popup, send the unhighlight command
        if (selectedMarkup instanceof KVMeasurement) {
          sendCommand({
            command: 'unhighlightAllMeasurements',
          })
        }
      }}>
      <CloseCircleOutlined style={{ transform: 'scale(1) translate(0, 0)' }} />
    </CloseButtonContainer>
  )
}
